import { StatusColors } from '@nexelem/components';
import { OrderStatus } from '@nexelem/api';
import { CustomTFunction, getTranslation } from '../../../../utils';

export type OrderStatusKeys = keyof typeof OrderStatus;
export type OrderStatusValues = (typeof OrderStatus)[OrderStatusKeys];
type OrderStatusSettings = {
  name: OrderStatusKeys;
  color: StatusColors;
  label: string;
};
export const getOrderStatusMap = (translation: CustomTFunction): Map<OrderStatusValues, OrderStatusSettings> => {
  const t = getTranslation(translation, 'orders.status');
  return new Map([
    [1, { name: 'draft', color: 'orange', label: t('draft') }],
    [2, { name: 'new', color: 'yellow', label: t('new') }],
    [3, { name: 'inProgress', color: 'blue', label: t('inProgress') }],
    [4, { name: 'cancelled', color: 'brown', label: t('cancelled') }],
    [5, { name: 'done', color: 'green', label: t('done') }],
    [6, { name: 'partiallyShipped', color: 'violet', label: t('partiallyShipped') }],
    [7, { name: 'shipped', color: 'violet', label: t('shipped') }],
    [8, { name: 'deleted', color: 'brown', label: t('cancelled') }],
  ]);
};
export const orderStatusMap = (t: CustomTFunction, status?: OrderStatusValues): OrderStatusSettings | undefined => {
  if (status) {
    const statusMap = getOrderStatusMap(t);
    return statusMap.get(status);
  }
};
